import {createRule, type Maybe} from '@regle/core';
import {isFilled} from '@regle/rules';
import {useTranslation} from '#imports';
import {checkRegistrationByCountry, getRegistrationNumberExampleByCountry, getRegistrationNumberTypeByCountry} from './validators/main.validator';

/**
 * Check if a registration number is valid for the country provided
 *
 * @param countryCode the country you want to check
 *
 * @example
 * ```ts
 *  import { useRegle, registrationNumber } from '@malt/forms';
 *
 * const countryCode = ref('FR');
 *
 *  const { r$ } = useRegle(... , {
 *    regNumber: { registrationNumber: registrationNumber(countryCode) }
 *  })
 * ```
 * */
export const registrationNumber = createRule({
    type: 'registrationNumber',
    validator(value: Maybe<string>, countryCode: string) {
        if (isFilled(value)) {
            return checkRegistrationByCountry(value, countryCode);
        }
        return true;
    },
    message: ({$params: [countryCode]}) => {
        const {t} = useTranslation();
        const registrationNumberExample = getRegistrationNumberExampleByCountry(countryCode) || '';
        const registrationNumberType = getRegistrationNumberTypeByCountry(countryCode) || '';
        return t('generic.forms.validation.errors.registrationNumber', [registrationNumberExample, registrationNumberType]);
    },
});
